import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from '../../../../../services/user-services/user.service';
import {AuthenticationService} from '../../../../../services/authentication.service';
import {CalendarComponent} from '../../../../../shared/components/ux/calendar/calendar.component';
import {MatTabGroup} from '@angular/material/tabs';
import {PropertiesService} from '../../../../../admin/admin-services/properties.service';
import {DomSanitizer} from '@angular/platform-browser';
import {ProcessSharedService} from '../../../../../services/process-shared.service';
import {ComponentModalFavoriteComponent} from '../component-modal-favorite/component-modal-favorite.component';
import {FaqAccordionComponent} from '../../../../../components/faq-accordion/faq-accordion.component';
import {
  AccommodationReservationProcessComponent
} from '../../../../../shared/components/accommodation-specific/accommodation-reservation-process/accommodation-reservation-process.component';
import {
  AccommodationItemCardComponent
} from '../../../../../shared/components/accommodation-specific/accommodation-item-card/accommodation-item-card.component';
import {ComponentOwnerComponent} from '../component-owner/component-owner.component';
import {
  AccommodationPriceBoxComponent
} from '../../../../../shared/components/accommodation-specific/accommodation-price-box/accommodation-price-box.component';
import {
  AccommodationMapComponent
} from '../../../../../shared/components/accommodation-specific/accommodation-map/accommodation-map.component';
import {
  AccommodationFeaturesComponent
} from '../../../../../shared/components/accommodation-specific/accommodation-features/accommodation-features.component';
import {
  AccommodationPhotoComponent
} from '../../../../../shared/components/accommodation-specific/accommodation-photo/accommodation-photo.component';
import {NgClass, NgIf} from '@angular/common';
import {HelperService} from '../../../../../services/helper.service';
import {Subscription} from 'rxjs';
import {PlatformService} from '../../../../../services/platform-service.service';
import { LocalSettingsService } from 'src/app/services/local-settings.service';

//import {MetaService} from 'src/app/services/meta.service';

@Component({
    selector: 'app-component-property',
    templateUrl: './component-property.component.html',
    styleUrls: ['./component-property.component.scss'],
    standalone: true,
    imports: [NgIf, AccommodationPhotoComponent, NgClass, AccommodationFeaturesComponent, AccommodationMapComponent, AccommodationPriceBoxComponent, ComponentOwnerComponent, AccommodationItemCardComponent, AccommodationReservationProcessComponent, FaqAccordionComponent, ComponentModalFavoriteComponent, TranslateModule]
})
export class ComponentPropertyComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() room;
  @Input() favList = [];
  @Input() FaqItems;
  @Input() selectedCity = 'lille';
  @Input() userOngoingBookings = [];

  locale: string;
  amenities_1 = [];
  amenities_2 = [];
  currentId;
  propertyPhotos = [];

  otherRooms = [];

  urlPrefix = '';

  // Date
  isMobile;
  process;
  userInformations;
  virtualVisit;

  showFavErrorModal = false;
  languages = [];

  border = 'start';
  public showMoreBtn: boolean = false;
  public showDesc: boolean = false;
  private eventSubscription: Subscription;


  @ViewChild('matTabGroup') matTabGroup: MatTabGroup;
  @ViewChild('CalendarComponent') CalendarComponent: CalendarComponent;
  @ViewChild('resaBox') resaBox;
  @ViewChild('displayBox') displayBox;
  @ViewChild('calendarModal') calendarModal;
  currentLanguage: string;



  constructor(
    private _translateService: TranslateService,
    private route: ActivatedRoute,
    private userService: UserService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private propertiesService: PropertiesService,
    private sanitizer: DomSanitizer,
    private processSharedService:ProcessSharedService,
    private helperService: HelperService,
    private platformService: PlatformService,
    private _localsettings: LocalSettingsService

  ) { }

  ngOnInit(): void {
    
    this._localsettings.language$.subscribe(
      (language: string) => {
        this.currentLanguage = language;
      }
    );
    //----- MOBILE
    this.isMobile = this.userService.isMobileUser;

    //---- AMENITIES
    this.processSharedService.getAmenities().subscribe(
        (data) => {
          this.setAmenities(data);
        }
    );

    if (this.authenticationService.currentUserValue){
      this.urlPrefix = '/';
    }
    //---- ROOM ID
    if (!this.room) {
      this.currentId = this.route.snapshot.paramMap.get('id');
    } else {
      this.currentId = this.room.id;
      if (this.authenticationService.currentUserValue){
        this.userInformations = this.userService.getInfos();

        this.userService.getCityById(this.room.property_address.city_group).subscribe((data: any) => {
          let datas = {
            budget: this.room.price ,
            city: data.name,
            property_fees: this.room.property_price.reservation_fees,
            property_id: this.room.id ,
            property_name: this.room.name,
            campagne: '',
            source: '',
            medium: ''
          };

          datas = this.helperService.setUtmToHubspot(datas);
          this.userService.setHubspotDeal(3321704, 11339145,datas).subscribe();
        });
        //this.metaService.sendPageView('/accommodation/property/' + this.room.id ,this.authenticationService.currentUserValue.id).subscribe();

      }
      /*else{
        //this.metaService.sendPageView('/accommodation/property/' + this.room.id ,0).subscribe();
      }*/
      if(this.room.virtualVisit){
        this.virtualVisit = this.sanitizer.bypassSecurityTrustHtml(this.room.virtualVisit);
      }
      // checkin hour
      if (this.room.partner) {
        const t = JSON.parse(this.room.partner.checkInSchedule);
        if (t) {
          this.room['checkin'] = [
            {morning: t.mondayAm, afternoon: t.mondayPm},
            {morning: t.tuesdayAm, afternoon: t.tuesdayPm},
            {morning: t.wednesdayAm, afternoon: t.wednesdayPm},
            {morning: t.thursdayAm, afternoon: t.thursdayPm},
            {morning: t.fridayAm, afternoon: t.fridayPm},
            {morning: t.saturdayAm, afternoon: t.saturdayPm},
            {morning: t.sundayAm, afternoon: t.sundayPm},
          ];
        }

        this.languages = JSON.parse(this.room.partner.languages);
      }
    }

    //---- LANG
    this.locale = this._translateService.currentLang;

    //--- OTHER ROOMS
    this.processSharedService.getHouseRooms(this.currentId).subscribe((data) => {
      this.otherRooms = data;
    });

    //---- PHOTOS
    this.propertyPhotos = [];
    this.propertyPhotos = this.room.property_photos;
    if (this.room.virtualVisit) {
      this.propertyPhotos.push(this.propertyPhotos[0]);
    }

    this.eventSubscription = this.platformService.eventEmitter.subscribe(data => {
      this.locale = data;
    });
  }

  ngAfterViewInit() {
    localStorage.removeItem('city');
    const descBlock: any = document.getElementsByClassName('line-clamp')[0];
    this.showMoreBtn = descBlock.offsetHeight < descBlock.scrollHeight || descBlock.offsetWidth < descBlock.scrollWidth;

  }

  ngOnDestroy(): void {
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
    }
  }


  returnUrl(element) {
    const url = window.location.protocol + '//' + window.location.host;
    switch (element) {
      case 'home': {
        return url + this.currentLanguage +'/discover';
      }
      case 'list': {
        return url + this.currentLanguage +'/accommodation/list'
      }
      case 'city' : {
        return url + this.currentLanguage +'/accommodation/list/' + this.helperService.slugify(this.selectedCity);
      }
      case 'type' : {
        return url + this.currentLanguage +'/accommodation/list/' + this.helperService.slugify(this.selectedCity) + '?type=' + this.room['partner_type'];
      }
    }
  }

  setAmenities(data) {
    if (this.amenities_1.length > 0 || this.amenities_2.length > 0) {
      return;
    }
    if (typeof this.room.amenities == 'string') {
      this.room.amenities = this.room.amenities.split(',');
    }
    const roomAm = data.filter(d => this.room.amenities.includes(d.id.toString()));
    if (this.room.partner_type === 'room') {
      this.amenities_1 = roomAm.filter(am => am.type_id === 1);
      this.amenities_2 = roomAm.filter(am => am.type_id === 2);
    } else {
      this.amenities_2 = roomAm;
    }
  }

  goBack() {
    if(this.selectedCity){
      this.router.navigate([this.urlPrefix + this.currentLanguage + '/accommodation/list/'+ this.helperService.slugify(this.selectedCity)]);
    }
    else{
      this.router.navigate([this.urlPrefix +this.currentLanguage + '/accommodation/list/']);
    }
  }

  // add every editable property in switch case
  public change(type, event) :void {
    if (event.inputType == 'insertText') {
      switch (type) {
        case 'reservation' : {
          const value = event.target.innerText.split(' ');
          if (value) {
            value.forEach(v => {
              if (Number.parseInt(v)) {
                this.room['minimal_stay_duration'] = Number.parseInt(v);
              }
            })
          }
          break;
        }
      }
    }
  }

  public manageDesc(): void {
    this.showDesc = !this.showDesc;
  }


}
